import { Switch } from '@/global/components/Switch'
import Grid from '@/global/components/ui/Grid'
import { hasPermission } from '@/hooks/useBackendMenu'
import { TextField } from '@mui/material'
import { Button } from 'global/components/Button'
import { FormField, FormFieldSelect } from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { clientes, planoDiferenciado } from 'service/api'
import { toast } from 'sonner'
import FormPlanoDiferenciado from '../forms/FormPlanoDiferenciado'

export default function PlanoDiferenciado() {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const { watch, setValue } = useFormContext()

    const { mutateAsync, isLoading } = planoDiferenciado.mutations.useDelete({
        onSuccess: () => {
            toast.success('Plano cancelado com sucesso')
            clientes.invalidateQueries()
            navigate(-1)
        },
        onError: (e: any) => {
            toast.error(e.messsage || 'Erro ao cancelar plano')
        },
    })

    const [valorCentavos, alterarPlano, existePlanoDiferenciado] = watch([
        'PlanoDiferenciado.valorCentavos',
        'PlanoDiferenciado.editar',
        'existePlanoDiferenciado',
    ])

    const valorReais = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format((valorCentavos ?? 0) / 100)

    useEffect(() => {
        if (!alterarPlano) {
            setValue(
                'PlanoDiferenciado.periodicidade',
                existePlanoDiferenciado?.periodicidade,
            )
            setValue(
                'PlanoDiferenciado.limiteFuncionarios',
                existePlanoDiferenciado?.limiteFuncionarios,
            )
            setValue(
                'PlanoDiferenciado.valorCentavos',
                existePlanoDiferenciado?.valorCentavos,
            )
        }
    }, [alterarPlano])

    const canEdit = hasPermission(['update', 'Clientes'])

    return (
        <Grid container spacing={2}>
            {!!existePlanoDiferenciado && (
                <>
                    <Grid item xs={6} className="mb-2">
                        <span className="inline-flex items-center gap-2">
                            <Switch
                                disabled={!canEdit}
                                checked={alterarPlano}
                                onChange={(_, c) =>
                                    setValue('PlanoDiferenciado.editar', c)
                                }
                            />
                            <span>Alterar plano diferenciado</span>
                        </span>
                    </Grid>
                    <Grid item xs={6} className="mb-2 inline-flex">
                        <div style={{ flex: 1 }} />
                        <Button
                            color="error"
                            onClick={() => setOpen(true)}
                            disabled={!canEdit}
                        >
                            Cancelar plano
                        </Button>
                    </Grid>
                </>
            )}
            <Grid item xs={12}>
                <FormFieldSelect
                    name="PlanoDiferenciado.periodicidade"
                    label="Periodicidade"
                    options={[
                        { value: 'monthly', label: 'Mensal' },
                        { value: 'quarterly', label: 'Trimestral' },
                        { value: 'yearly', label: 'Anual' },
                    ]}
                    disabled={!alterarPlano}
                />
            </Grid>
            {alterarPlano && <FormPlanoDiferenciado />}
            <Grid item xs={6}>
                <FormField
                    name="PlanoDiferenciado.limiteFuncionarios"
                    label="Limite de funcionários"
                    InputProps={{
                        readOnly: true,
                    }}
                    disabled={!alterarPlano}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label="Preço final"
                    InputProps={{
                        readOnly: true,
                    }}
                    variant="filled"
                    value={valorReais}
                    disabled={!alterarPlano}
                    fullWidth
                />
            </Grid>
            <Dialog.Root
                open={open}
                onClose={() => setOpen(false)}
                onSubmit={() => mutateAsync(existePlanoDiferenciado.clienteId)}
                height="auto"
                loading={isLoading}
            >
                <Dialog.Title>Tem certeza</Dialog.Title>
                <Dialog.Content>
                    O cliente continuará utilizando o sistema até o final do
                    período contratado, depois disso terá que contratar um novo
                    plano.
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                    <Dialog.Actions.PrimaryButton closeOnSubmit>
                        Confirmar
                    </Dialog.Actions.PrimaryButton>
                </Dialog.Actions>
            </Dialog.Root>
        </Grid>
    )
}
